module.exports = __webpack_public_path__ + "img/8-text.dd5fe225.png";